import { createContext } from 'react'

import { LOGIN_FALLBACK_UI_CONFIG, type UiConfig } from './uiConfig'

export type UiConfigStatus = 'loading' | 'ready' | 'error'

export interface UiConfigState {
  config: UiConfig
  status: UiConfigStatus
  error?: string
  /**
   * Best-effort reload of a *pinned* client-config revision by its microapp
   * document id. Used to lock the config for the life of an order so the form
   * a clinician sees stays stable even if the live config changes mid-draft.
   * Resolves ``true`` when the pinned revision was applied, ``false`` otherwise
   * (current config is left intact on failure). Undefined outside the provider.
   */
  reloadByConfigId?: (organizationId: string, configId: string) => Promise<boolean>
}

export const UiConfigContext = createContext<UiConfigState>({
  config: LOGIN_FALLBACK_UI_CONFIG,
  status: 'loading',
})
